import { isDate, isMatch, getYear, parse } from "date-fns";
import { useState, useEffect } from "react";
import { DATE_STRING_FORMAT } from "../Constants/stringFormats";

export default function useCalendarYear(defaultValue, format) {
    const [calendarYear, setCalendarYear] = useState(null);
    const [value, setValue] = useState(defaultValue);

    useEffect(() => {
        const determinedFormat = format || DATE_STRING_FORMAT;

        let year;
    
        if (isDate(value)) {
            year = getYear(value);
        } else if (isMatch(value, determinedFormat)) {
            const parsedDate = parse(value, determinedFormat, new Date());
            
            year = getYear(parsedDate);
        }

        setCalendarYear(year || null);
    }, [value]); 

    return [calendarYear, setValue];
}